<script setup>
import { ref } from 'vue'
import TransfertCreationForm from '@/components/fiche-aim/fiche-aim/ajustement/transfert-creation-form.vue'
import AjustementCreationForm from '@/components/fiche-aim/fiche-aim/ajustement/ajustement-creation-form.vue'

const emits = defineEmits(['created', 'close'])

const { ficheAimId } = defineProps({
  ficheAimId: {
    type: Number,
    required: true,
  },
  active: {
    type: Boolean,
    required: true,
  },
})

const mode = ref('DEFAULT')
function switchToMode() {
  mode.value = mode.value === 'DEFAULT' ? 'ADVANCED' : 'DEFAULT'
}
</script>

<template>
  <v-bottom-sheet :value="active" inset origin="left bottom" persistent @close="$emit('close')">
    <v-card flat>
      <v-card-title>
        <v-row align="center" justify="space-between">
          <v-col cols="auto"> Création d'ajustement </v-col>
          <v-col cols="auto">
            <v-tooltip top>
              Passer au mode {{ mode === 'ADVANCED' ? 'par défaut' : 'avancé' }}
              <template #activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  class="rounded-pill"
                  :color="mode === 'ADVANCED' ? 'secondary' : 'white'"
                  @click="switchToMode"
                >
                  <v-icon>mdi-tune-vertical-variant</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text v-if="mode === 'DEFAULT'">
        <transfert-creation-form
          :fiche-aim-id="ficheAimId"
          @created="(aj) => emits('created', aj)"
          @close="$emit('close')"
        />
      </v-card-text>
      <v-card-text v-if="mode === 'ADVANCED'">
        <ajustement-creation-form
          :fiche-aim-id="ficheAimId"
          @created="(aj) => emits('created', aj)"
          @close="$emit('close')"
        />
      </v-card-text>
    </v-card>
  </v-bottom-sheet>
</template>
